import Vue from "vue";
import store from "./../../store";
import moment from "moment";

// When the request succeeds
const success = () => {
  store.dispatch("getAccount");
};

// When the request fails
const failed = () => {
  store.dispatch("logout");
  Vue.router.push({
    name: "login.index",
  });
};

export default () =>
  Vue.$http
    .get("/account")
    .then((response) => {
      if (response && response.status === 200) {
        // $crisp.push(["set", "user:email", [response.data.user.email]]);
        // $crisp.push(["set", "user:phone", [response.data.user.phone]]);
        // $crisp.push([
        //   "set",
        //   "user:nickname",
        //   [response.data.user.first_name + " " + response.data.user.last_name],
        // ]);
        // $crisp.push(["set", "user:firstname", [response.data.user.first_name]]);
        // $crisp.push(["set", "user:lastname", [response.data.user.last_name]]);
        // $crisp.push(["set", "session:segments", [["customer"]]]);
        // $crisp.push([
        //   "set",
        //   "session:data",
        //   [
        //     [
        //       ["stripe_id", response.data.user.stripe_id],
        //       ["total_rental", response.data.user.total_rental],
        //       ["created_at", response.data.user.created_at],
        //       [
        //         "account_age",
        //         moment().diff(moment(response.data.user.created_at), "days"),
        //       ],
        //     ],
        //   ],
        // ]);

        success(response.data.user);
      }
    })
    .catch((error) => {
      failed(error);
    });



// WEBPACK FOOTER //
// ./src/app/services/account/find.js